// extracted by mini-css-extract-plugin
export var animateOpacity = "theme-toggle-module--animateOpacity--6cee6";
export var background = "theme-toggle-module--background--07bbf";
export var checkbox = "theme-toggle-module--checkbox--32be2";
export var fadeIn = "theme-toggle-module--fadeIn--e6e95";
export var option = "theme-toggle-module--option--a2a8c";
export var selected = "theme-toggle-module--selected--d21f8";
export var slider = "theme-toggle-module--slider--a69a4";
export var toggle = "theme-toggle-module--toggle--38838";